import ExternalDoorReplacement from './ExternalDoorReplacement';

export default ExternalDoorReplacement;